import React from "react";
import { Navigate } from "react-router-dom";

function PublicRoute({ component: RouteComponent }) {
  const isAuthenticated = localStorage.getItem("token");
  if (isAuthenticated) {
    return <Navigate to="/" />;
  } else {
    return <RouteComponent />;
  }
}

export default PublicRoute;
